
import React, { Component } from "react";

import { BsyUtils } from '../../../utils/Utils';
import BsySearchInput from "../../BsySearchInput";
import './index.css';
import SearchDash from './searchDash'
import BsySearchResult from "../../BsySearchResult";



export default class BsyDashboardCustomDashConfig extends Component {

    constructor(props) {
        super(props)
        this.state = {
            apps: [],
            appMaps: {},
            customDash: props.customDash,
            block: props.block,
            key: '',
            seachList: [],
        }

    }

    getAppList = () => {
        React.axios('/dashboard/app_group/list').then(res => {
            if (res.data.code === 0) {

                this.setState({
                    apps: [...res.data.items],
                }, () => {
                    // this.onSelectApp(this.state.appid);
                })
            } else {
                BsyUtils.showAjaxTip(res.data, () => {
                    this.setState({
                        apps: [...res.data.items],
                    }, () => {
                        // this.onSelectApp(this.state.appid);
                    })
                })
            }
        }).catch(res => {

        })
    }
    componentDidMount() {
        this.getAppList();
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        const items = { ...nextProps.customDash }
        const block = { ...nextProps.block }
        this.setState({
            customDash: items,
            block: block,
        })
    }



    entryClick = (e) => {
        e.stopPropagation();
    }

    onSelectEntry = (entry,e) => {
        const { appMaps } = this.state;
        if (!entry) {
            return;
        }
        let event = e.currentTarget;
        let _id = [entry.appId, entry.entryId].join('@');

        if (appMaps[_id]) {
            const newAppMap = {
                ...appMaps,
                [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
            }
            if (newAppMap[_id].open) {
                event.classList.add("open")
            } else {
                event.classList.remove("open")
            }
            this.setState({
                appMaps: newAppMap,
            })
            return;
        }
        else {
            event.classList.add("open")
        }
        React.axios('/dashboard/app/' + entry.appId + '/entry/' + entry.entryId, {}).then(res => {

            let components = [];


            BsyUtils.forEach(res.data.entry.components, (dd, data) => {
                if (!data) {
                    return;
                }
                if (data.type.indexOf('filter') > -1) {
                    return;
                }
                if (data.type.indexOf('description') > -1) {
                    data.listName = React.language('dash.descriptionBtn')
                }
                if (data.type.indexOf('image') > -1) {
                    data.listName = React.language('dash.image')
                }
                if (data.type.indexOf('real_time') > -1) {
                    data.listName = React.language('dash.real.time')
                }
                if (data.type.indexOf('embedded_iframe') > -1) {
                    data.listName = React.language('dash.embedded.iframe')
                }
                if (data.type.indexOf('filte_quick') > -1) {
                    data.listName = React.language('dash.filter.quick')
                }
                if (data.type.indexOf('base_layout_container') > -1) {
                    data.listName = React.language('dash.embedded.layout.container')

                }
                components.push({ ...data, appId: entry.appId, entryId: entry.entryId })
            })
            let entryComponents = components.filter((data) => {
                return ['base_layout_container', 'filte_quick'].indexOf(data.type) === -1
            })
            console.log(entryComponents)
            const newAppMap = {
                [_id]: { components: entryComponents, open: true },
                ...appMaps,
            }
            this.setState({
                appMaps: newAppMap,
            })

        }).catch(res => {
            console.log(res)
        })
    }

    onSelectApp = (_id, e) => {
        const { appMaps } = this.state;
        if (!_id) {
            return;
        }
        let event = e.currentTarget;

        if (appMaps[_id]) {
            const newAppMap = {
                ...appMaps,
                [_id]: { ...appMaps[_id], open: !appMaps[_id].open },
            }
            if (newAppMap[_id].open) {
                event.classList.add("open")
            } else {
                event.classList.remove("open")
            }
            this.setState({
                appMaps: newAppMap,
            })
            return;
        } else {
            event.classList.add("open")
        }
        React.axios('/dashboard/app/' + _id, {}).then(res => {
            console.log(res)
            let entrys = [];
            window.FX.STATIC.user.dock_userid = res.data.dock_userid;
            res.data.entryList.map((data, index) => {
                if (data.child) {
                    BsyUtils.forEach(data.child, (index, childdata) => {
                        entrys.push({ ...res.data.entryMap[childdata.id], appId: _id })
                    })
                    // data.child.map((childdata, index) => {
                    //     entrys.push({ ...res.data.entryMap[childdata.id], appId: _id })
                    // })
                } else {
                    entrys.push({ ...res.data.entryMap[data.id], appId: _id })
                }
            })

            const newAppMap = {
                [_id]: { ...res.data, entrys: entrys, open: true },
                ...appMaps,
            }
            this.setState({
                appMaps: newAppMap,
            })

        }).catch(res => {
            console.log(res)
        })
    }


    getSearchValue = (ref) => {
        this.searchValue = ref
    }

    onSearch = () => {

        let key = this.searchValue.getValue();
        if (!key) {
            this.setState({
                key: "",
                seachList: [],
            })
            return
        }
        React.axios('/dashboard/search', {
            keyword: key,
            type: "entry",
            range: 'noStandard'
        }).then(res => {
            this.setState({
                key: this.searchValue.getValue(),
                seachList: res.data.list,
            })
        }).catch(res => {
            console.error(res);
        })


    }
    findEntryS = (block) => {
        const { customDash } = this.state;

        let widget = []

        BsyUtils.forEach(customDash.dash, (index, data) => {
            if ([data.appId, data.entryId, data.widgetId].join("@") === [block.appId, block.entryId, block.widgetId].join("@")) {
                widget.push(data)
            }
        })

        // const s = customDash.dash.filter((data, index) => {

        //     return [data.appId, data.entryId, data.widgetId].join("@") === [entry.appId, entry.entryId, entry.widgetId].join("@")
        // })
        return widget.length > 0;
    }

    getValue = () => {
        const { customDash, block } = this.state;
        if (this.props.getValue) {
            this.props.getValue({
                ...customDash, dash: [...customDash.dash, {
                    appId: block.appId,
                    entryId: block.entryId,
                    widgetId: block.widgetId,
                    width: this.component.width,
                    height: this.component.height,
                    widgetParams: { ...this.component },
                }]
            }, block)
        }
    }

    componentsAdd = (component) => {
        const { block } = this.state;
        this.component = { ...component }
        this.setState({
            block: {
                ...block,
                appId: component.appId,
                entryId: component.entryId,
                widgetId: component.widgetId,
                name: component.title,
            },
        }, () => {
            this.getValue();
        })
    }

    renderComponentlist = (appInfo) => {
        const { appMaps, block } = this.state;

        let _id = [appInfo.appId, appInfo.entryId].join('@');

        if (appMaps[_id]) {

            if (!appMaps[_id].open) {
                return '';
            }

            let components = appMaps[_id].components;
            console.log(1)
            return <div className='dash-components' >
                {
                    components.length === 0 ? <div className="components-item empty"><span className="entry-title">当前应用没有可使用报表</span></div> :
                        components.map((data, index) => {
                            return <div className={'components-item'}
                                key={'components-item-' + index}
                                onClick={e => { e.stopPropagation(); !this.findEntryS(data) && this.componentsAdd(data) }} >
                                <span className={'entry-title'}>{data.title || data.listName}</span>
                                <span className={'right-entry-title'}>{
                                    this.findEntryS(data)
                                        ? <span className='read-tip'>{React.language('add.already')}</span>
                                        : [data.appId, data.entryId, data.widgetId].join("@") === [block.appId, block.entryId, block.widgetId].join("@") ? <i className='icon-ok' /> : ''
                                }</span>
                            </div>
                        })
                }
            </div>
        } else {
            return '';
        }
    }

    renderEntryList = (appInfo) => {
        const { appMaps } = this.state;
        if (appMaps[appInfo._id]) {

            if (!appMaps[appInfo._id].open) {
                return '';
            }
            let dashs = appMaps[appInfo._id].entrys.filter((data, index) => {
                return data.type === 'dash' && data.type !== "base_layout_container"
            })

            return <div className='app-entrys' >
                {
                    dashs.length === 0 ? <div className="entry-item-title empty"><span className="entry-title">当前应用没有可使用报表</span></div> :
                        dashs.map((data, index) => {

                            if (data.type !== 'dash') {
                                return '';
                            }
                            return <>
                                <div className={'entry-item-title'} key={'entry-item-title-' + index} onClick={e => { e.stopPropagation(); this.onSelectEntry(data,e) }} >
                                    <i className="t-icon-up-down icon-bsy-sort-desc"></i>
                                    <i className={'entry-icon ' + BsyUtils.getFormIcon(data)} />
                                    <span className={'entry-title'}>{data.name}</span>

                                </div>
                                {
                                    this.renderComponentlist(data)
                                }
                            </>
                        })
                }
            </div>
        } else {
            return '';
        }

    }

    renderApplist = () => {
        const { apps } = this.state;
        let that = this;
        return <>
            {
                apps.map((data) => {
                    return data.apps.map((appdata) => {
                        return <div className={"applist-item "} >
                            <div className='app-title' onClick={e => { that.onSelectApp(appdata._id, e) }}  >
                                <i className="t-icon-up-down icon-bsy-sort-desc"></i>
                                <div className={"app-icon color-cover-" + appdata.style.color}><div className={"imgbg-bsy-app imgbg-bsy-app-" + appdata.style.icon} /></div>
                                <span>{appdata.appname}</span>
                            </div>
                            {
                                this.renderEntryList(appdata)
                            }
                        </div>
                    })
                })
            }
        </>
    }

    renderSeachlist = () => {
        const { seachList } = this.state;

        let dashs = seachList.filter((data) => {
            return data.type === 'dash' && data.type !== "base_layout_container"
        })



        return <div className='applist-item '>
            <div className='app-entrys' >
                {

                    dashs.length === 0 ? <div className="entry-item-title empty"><span className="entry-title">未搜索到可使用报表</span></div> :
                        dashs.map((data) => {

                            return <>
                                <div className={'entry-item-title'} onClick={e => { e.stopPropagation(); this.onSelectEntry(data,e) }} >
                                    <i className={'entry-icon ' + BsyUtils.getFormIcon(data)} />
                                    <span className={'entry-title'}>{data.name}</span>

                                </div>
                                {
                                    this.renderComponentlist(data)
                                }
                            </>
                        })
                }
            </div>
        </div>
    }

    render() {
        const { key, block } = this.state;
        return (
            <div className={"dashboard-custom-dash-config"}>

                <div className={"left-app-list"}>
                    <div className='applist-seach'>
                        <BsySearchResult
                            placeholder={React.language('form.search.placeholder')}
                            width={455}
                            height={280}
                            dockPosition="center"
                            async={{
                                url: '/dashboard/search',
                                data: {
                                    type: 'dash',
                                    range: 'noStandard'
                                },
                                sucess: (items) => {
                                    return items.list
                                }
                            }}
                            onCreatResult={(res) => {
                                let otherItem = [];
                                if (res && res.length > 0) {
                                    res.map((val) => {
                                        if (val.type !== "app") {
                                            otherItem.push(val)
                                        }
                                    })
                                }
                                return <SearchDash getValue={this.getValue} componentsAdd={this.componentsAdd} findEntryS={this.findEntryS} res={res} block={block} otherItem={otherItem} />
                            }}
                            getValue={this.getSearchValue}
                            onSearch={this.onSearch}
                            type={window.mode}
                        // iconName="icon-bsy-reportmenu-0"
                        />
                    </div>
                    <div className='applist'>
                        {
                            !key ? this.renderApplist() : this.renderSeachlist()
                        }
                    </div>
                </div>
            </div>
        )
    }
}